import { delay } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import VideoModal from '@src/business-components/yt-video-modal';
import VideoModalStore from '@src/business-components/yt-video-modal/store';
import useModal from '@src/utils/hooks/use-modal';
import Toast from '@src/components/toast';
import useMount from '@src/utils/hooks/use-mount';
import { observable, computed } from 'mobx';
import cmsApi from '@src/services/cms-api';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import { aLink } from '@src/utils/common-util';
const pageLocalesData = getPageLocalesData();

class FirstSectionStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  videoModalStore = new VideoModalStore();
  // 视频
  @observable pvVideoUrl = '';
  // 是否在下载游戏时间内
  @observable isDownLoadTime = 0;
  // 是否激活
  @observable isActive = false;

  onBook = null; // 外部传入

  @observable steam_url; // steam 链接

  @autobind
  async playPvVideo() {
    // this.pvVideoUrl = '';
    if (!this.pvVideoUrl) {
      Toast.info(`${pageLocalesData.global.comming_soon}`);
    } else {
      await delay(300);
      this.videoModalStore.src = this.pvVideoUrl;
      this.videoModal.open({ extraProps: { store: this.videoModalStore } });
    }
  }

  aLinkSteam() {
    if (this.steam_url) {
      aLink(this.steam_url);
    }
  }

  getNewsListAndVideoUrlAsync = async () => {
    return await cmsApi
      .makeCmsCustomConfigRequest('//www.mechabreak.com/api/config/tag/', 'zt/mechabreak_pre_dlc_20241205')
      .then(res => {
        // console.log(res);
        let currentLanguage = getLanguageByPath();
        if (currentLanguage === 'zh-Hant') {
          currentLanguage = 'zh_HK';
        }
        this.pvVideoUrl = res['video_url_' + currentLanguage];
      })
      .catch(e => {
        console.log(e);
      });
  };

  /**
   * 开启下载
   */
  @computed
  get downLoadBtnState() {
    return this.isDownLoadTime === 1;
  }

  use() {
    this.videoModal = useModal(VideoModal);
    useMount(() => {
      // this.playPvVideo();
      this.getNewsListAndVideoUrlAsync();
    });
  }
}

export default FirstSectionStore;
